import { render, staticRenderFns } from "./addPlanActivities.vue?vue&type=template&id=387e8b52&scoped=true&"
import script from "./addPlanActivities.vue?vue&type=script&lang=js&"
export * from "./addPlanActivities.vue?vue&type=script&lang=js&"
import style0 from "./addPlanActivities.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addPlanActivities.vue?vue&type=style&index=1&id=387e8b52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387e8b52",
  null
  
)

component.options.__file = "addPlanActivities.vue"
export default component.exports